
    import common from "@/util/common";

    import {defineComponent, toRefs} from "vue";

    // interface State {
    // }
    export default defineComponent({
        name: "remarkH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            // let state: State = reactive({
            // })
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            return {
                // state,
                getData
            }
        }
    })
